import React from "react";
import img1 from "../../assets/ingridients-images/livercare/aloe.webp";
import img2 from "../../assets/ingridients-images/livercare/amalaki.webp";
import img3 from "../../assets/ingridients-images/livercare/harad.webp";
import img4 from "../../assets/ingridients-images/livercare/kutki.webp";
import img5 from "../../assets/ingridients-images/livercare/loh-bhasma.webp";
import img6 from "../../assets/ingridients-images/livercare/chirata.webp";

const data = [
  {
    title: "Aloe Vera",
    img: img1,
    text: "Promotes cartilage health and flexibility",
  },
  {
    title: "Amalaki",
    img: img2,
    text: "Soothes discomfort & aids recovery",
  },
  {
    title: "Harad",
    img: img3,
    text: "Supports joint comfort and inflammation balance",
  },
   {
    title: "Kutki",
    img: img4,
    text: "Imporves flexibility & joint health",
  },
   {
    title: "Loh Bhasma",
    img: img5,
    text: "Enhances nutrient absorption",
  },
   {
    title: "Chirata",
    img: img6,
    text: "Promotes comfort",
  },

];

const LivercareIngredients = () => {
  return (
    <section className="ingredients">
      <h2 className="ingredients-title">
        Key Ingredients for Liver Care
      </h2>

      <div className="ingredients-grid">
        {data.map((item, index) => (
          <div className="ingredient-card" key={index}>
            <div className="pill">{item.title}</div>

            <div className="image-circle">
              <img src={item.img} alt={item.title} />
            </div>

            <p>{item.text}</p>
            <div className="card-shadow"></div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default LivercareIngredients;
